import { TwitterIcon, InstagramIcon } from "components/atoms/Icon";
import { ReactComponent as InsertLinkOutlinedIcon } from "assets/Icons/InsertLinkOutlined.svg";
import { GlobeAltIcon } from "@heroicons/react/24/outline";

type BrandSocial = Pick<Brand, "name" | "instagram_link" | "website_link" | "other_link" | "twitter_link">;

// In the brand social types we have used null in the profile_image_url, that's why we need to create new typer
// TODO: check types for this props in the whole application
interface BrandSocialCardTypes extends BrandSocial {
  profile_image_url: string;
}

export default function BrandSocialCardNew({
  name,
  website_link: brandWebsiteLink,
  other_link: otherLink,
  twitter_link: twitterLink,
  instagram_link: instagramLink,
  profile_image_url: brandProfileImage,
}: BrandSocialCardTypes) {
  const socialMediaLinks = [
    { icon: <GlobeAltIcon className="h-5 w-5 md:h-7 md:w-7" />, link: brandWebsiteLink },
    { icon: <TwitterIcon className="h-5 w-5 md:h-7 md:w-7" />, link: twitterLink },
    { icon: <InstagramIcon className="h-5 w-5 md:h-7 md:w-7" />, link: instagramLink },
    { icon: <InsertLinkOutlinedIcon className="h-5 w-5 text-primary md:h-7 md:w-7" />, link: otherLink },
  ];

  return (
    <section className="mt-4 flex text-primary md:mt-0">
      <img
        className="h-16 w-16 rounded-md border-1 border-white md:h-32 md:w-32 md:rounded-xl"
        src={brandProfileImage}
        alt={`${name} brand profile`}
      />
      <div className="ml-6 mt-1">
        <h1 className="mb-2 font-satoshi text-lg font-bold  md:text-xl">{name}</h1>
        <div className="flex gap-3">
          {socialMediaLinks.map(
            (social) =>
              social.link && (
                <a
                  key={social.link}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {social.icon}
                </a>
              ),
          )}
        </div>
      </div>
    </section>
  );
}
